(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("rrdiagram", [], factory);
	else if(typeof exports === 'object')
		exports["rrdiagram"] = factory();
	else
		root["rrdiagram"] = factory();
})(this, function() {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition